import React from 'react';

interface TextIconProps {
  className?: string;
  size?: number;
}

export const TextIcon: React.FC<TextIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Text cursor with organic shape */}
      <path
        d="M4 6h16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Text lines with natural spacing */}
      <path
        d="M4 12h12"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 18h8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Text cursor indicator */}
      <path
        d="M12 4v16"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.7"
        strokeDasharray="1 1"
      />
      {/* Subtle text shadow */}
      <path
        d="M4 6h16"
        stroke="currentColor"
        strokeWidth="0.5"
        opacity="0.3"
        strokeDasharray="1 1"
      />
    </svg>
  );
};

export default TextIcon;
